import React, { Component } from "react"
import { navigate } from "gatsby"
import Select, { components } from "react-select"
import chroma from "chroma-js"

import Link from "../utils/link"

import filter from "../assets/images/i/filter.png"

import { Search } from "../components/icons"

const rentPrice = [
  { label: "$100", value: 100 },
  { label: "$200", value: 200 },
  { label: "$300", value: 300 },
  { label: "$400", value: 400 },
  { label: "$500", value: 500 },
  { label: "$600", value: 600 },
  { label: "$700", value: 700 },
  { label: "$800", value: 800 },
  { label: "$900", value: 900 },
  { label: "$1000+", value: 10000 },
]

const priceMin = [
  { label: "$600,000", value: 600000 },
  { label: "$800,000", value: 800000 },
  { label: "$1,000,000", value: 1000000 },
  { label: "$1,200,000", value: 1200000 },
  { label: "$1,400,000", value: 1400000 },
  { label: "$1,600,000", value: 1600000 },
  { label: "$1,800,000", value: 1800000 },
  { label: "$2,000,000", value: 2000000 },
  { label: "$2,200,000", value: 2200000 },
  { label: "$2,400,000", value: 2400000 },
  { label: "$2,600,000", value: 2600000 },
  { label: "$2,800,000", value: 2800000 },
  { label: "$3,000,000", value: 3000000 },
  { label: "$4,000,000", value: 4000000 },
  { label: "$5,000,000", value: 5000000 },
  { label: "$6,000,000", value: 6000000 },
  { label: "$7,000,000", value: 7000000 },
  { label: "$8,000,000", value: 8000000 },
  { label: "$9,000,000", value: 9000000 },
  { label: "$10,000,000", value: 10000000 },
  { label: "$15,000,000", value: 15000000 },
  { label: "$20,000,000+", value: 500000000 },
]
const priceMax = [
  { label: "$800,000", value: 800000 },
  { label: "$1,000,000", value: 1000000 },
  { label: "$1,200,000", value: 1200000 },
  { label: "$1,400,000", value: 1400000 },
  { label: "$1,600,000", value: 1600000 },
  { label: "$1,800,000", value: 1800000 },
  { label: "$2,000,000", value: 2000000 },
  { label: "$2,200,000", value: 2200000 },
  { label: "$2,400,000", value: 2400000 },
  { label: "$2,600,000", value: 2600000 },
  { label: "$2,800,000", value: 2800000 },
  { label: "$3,000,000", value: 3000000 },
  { label: "$4,000,000", value: 4000000 },
  { label: "$5,000,000", value: 5000000 },
  { label: "$6,000,000", value: 6000000 },
  { label: "$7,000,000", value: 7000000 },
  { label: "$8,000,000", value: 8000000 },
  { label: "$9,000,000", value: 9000000 },
  { label: "$10,000,000", value: 10000000 },
  { label: "$15,000,000", value: 15000000 },
  { label: "$20,000,000+", value: 500000000 },
]

const bed_bath_park = [
  { label: "1+", value: 1 },
  { label: "2+", value: 2 },
  { label: "3+", value: 3 },
  { label: "4+", value: 4 },
  { label: "5+", value: 5 },
  { label: "6+", value: 6 },
]

let selection = []
if ( process.env.GATSBY_LOCATION === 'perth' ) {
  selection = [
    { label: "All", value: "all" },
    { label: "Buy", value: "buy" },
    { label: "Classic", value: "classics" },
    { label: "Sold", value: "sold" },
  ]
} else if ( process.env.GATSBY_LOCATION === 'nz' ) {
  selection = [
    { label: "Buy", value: "buy" },
    { label: "Sold", value: "sold" },
  ]
} else {
  selection = [
    { label: "All", value: "all" },
    { label: "Buy", value: "buy" },
    { label: "Classic", value: "classics" },
    { label: "Sold", value: "sold" },
  ]
}

const colourStyles = {
  control: styles => ({ ...styles, backgroundColor: "white" }),
  option: (styles, { data, isDisabled, isFocused, isSelected }) => {
    const color = chroma("#3c3c3c")
    return {
      ...styles,
      backgroundColor: isDisabled
        ? null
        : isSelected
        ? data.color
        : isFocused
        ? color.alpha(0.1).css()
        : null,
      color: isDisabled
        ? "#ccc"
        : isSelected
        ? chroma.contrast(color, "white") > 2
          ? "white"
          : "black"
        : data.color,
      cursor: isDisabled ? "not-allowed" : "default",

      ":active": {
        ...styles[":active"],
        backgroundColor:
          !isDisabled && (isSelected ? data.color : color.alpha(0.3).css()),
      },
    }
  },
  input: styles => ({ ...styles }),
  placeholder: styles => ({ ...styles }),
  singleValue: (styles, { data }) => ({ ...styles }),
}

const DropdownIndicator = props => {
  let style = {}
  if (props.selectProps.menuIsOpen) style.transform = "rotate(180deg)"

  return (
    <components.DropdownIndicator {...props}>
      <svg
        style={style}
        width="6px"
        height="5px"
        viewBox="0 0 101 88"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g stroke="none" strokeWidth="1" fillRule="evenodd" fill="#3C3C3C">
          <polygon
            transform="translate(50.422003, 44.000000) rotate(-90.000000) translate(-50.422003, -44.000000) "
            points="93.844005 94 7 44 93.844005 -6"
          ></polygon>
        </g>
      </svg>
    </components.DropdownIndicator>
  )
}

class SearchForm extends Component {
  static defaultProps = {
    list: [],
    set: () => {},
    type: "all",
    dark: false,
  }

  state = {
    searchPlaceholder: `Search properties`,
    form: {
      search: "",
      selection: null,
      option: selection.find(el => el.value === this.props.type) || null,
      bedrooms: null,
      bathrooms: null,
      carparks: null,
      price_min: null,
      price_max: null,
    },
    show: false,
    fixed: false,
    expandActive: false,
  }

  constructor(props) {
    super(props)
    this.updateList()
  }

  componentDidMount() {
    this.updateDimensions()
    window.addEventListener("resize", this.updateDimensions)
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions)
  }

  updateDimensions = () => {
    if (window.innerWidth < 900) {
      this.setState({ searchPlaceholder: `Search` })
    } else {
      this.setState({ searchPlaceholder: `Search properties` })
    }
  }

  _toggleExpand = () => {
    this.setState({ expandActive: !this.state.expandActive })
  }

  _hideExpand = () => {
    this.setState({ expandActive: false })
  }

  _handleChange = (option, field) => {
    clearTimeout(this.timeout)
    let { form } = this.state
    switch (field && field.action) {
      case "select-option":
        form[field.name] = option
        this.setState({ form }, this.updateList)
        break
      default:
        let { name, value } = option.currentTarget
        form[name] = value
        this.setState({ form }, () => {
          this.timeout = setTimeout(() => {
            this.updateList()
          }, 150)
        })
        break
    }
  }

  _selectChange = option => {
    if (option.value === "all") return navigate("/")
    navigate(`/${option.value}`)
  }

  updateList = () => {
    const { list, set } = this.props
    const {
      bedrooms,
      bathrooms,
      carparks,
      price_min,
      price_max,
      search,
    } = this.state.form

    let results = {}
    results = list.filter((el, i) => {
      const { propertyMeta, propertyData } = el
      if (bedrooms && parseInt(propertyMeta.beds) < bedrooms.value) return false
      if (bathrooms && parseInt(propertyMeta.baths) < bathrooms.value) return false
      if (
        carparks &&
        parseInt(propertyMeta.cars) + parseInt(propertyMeta.garages) < carparks.value
      )
        return false
      if (price_min && parseInt(propertyData.price_from) < price_min.value) return false
      if (price_max && parseInt(propertyData.price_to) > price_max.value) return false
      if (search) {
        let title = el.title.toLowerCase()
        let find = search
          .toLowerCase()
          .trim()
          .split(", ")
          .reduce((a, b) => {
            if (a) return a
            return title.indexOf(b) !== -1
          }, false)
        if (!find) return false
      }
      return true
    })
    set(results)
  }

  render() {
    let { expandActive } = this.state
    let {
      option,
      price_min,
      price_max,
      bedrooms,
      bathrooms,
      carparks,
    } = this.state.form
    const { dark, type } = this.props

    let className = `search ${expandActive ? "search--expand" : ""} ${
      dark ? "search--dark" : ""
    }`

    return (
      <section id="property-search" className={className} data-color={dark ? "#4B4B4D" : "#FFFFFF"}>
        <div className="search__inner">
          <form
            className="search__form form"
            onSubmit={e => e.preventDefault()}
          >
            <div className="form__row form__row__dropdowns">
              <div
                className="form__select form__select__selection"
                onClick={() => this.selection.focus()}
              >
                <Select
                  components={{ DropdownIndicator }}
                  styles={colourStyles}
                  options={selection}
                  onChange={this._selectChange}
                  openMenuOnFocus={true}
                  isSearchable={false}
                  id="selection"
                  name="selection"
                  value={option}
                  placeholder="All"
                  className="react-select-container"
                  classNamePrefix="react-select"
                  ref={node => (this.selection = node)}
                />
              </div>
              <div className="form__row form__row__search">
                <input
                  className="form__input"
                  type="text"
                  name="search"
                  placeholder={this.state.searchPlaceholder}
                  onChange={this._handleChange}
                />
                <Search color="#000000" />
              </div>

              <div
                className="form__select form__select__min"
                onClick={() => this.min.focus()}
              >
                <Select
                  components={{ DropdownIndicator }}
                  styles={colourStyles}
                  options={type === "lease" ? rentPrice : priceMin}
                  onChange={this._handleChange}
                  openMenuOnFocus={true}
                  id="price_min"
                  name="price_min"
                  value={price_min}
                  placeholder="Min Price"
                  isSearchable={false}
                  className="react-select-container"
                  classNamePrefix="react-select"
                  ref={node => (this.min = node)}
                />
              </div>
              <div
                className="form__select form__select__max"
                onClick={() => this.max.focus()}
              >
                <Select
                  components={{ DropdownIndicator }}
                  styles={colourStyles}
                  options={type === "lease" ? rentPrice : priceMax}
                  onChange={this._handleChange}
                  openMenuOnFocus={true}
                  id="price_max"
                  name="price_max"
                  value={price_max}
                  placeholder="Max Price"
                  isSearchable={false}
                  className="react-select-container"
                  classNamePrefix="react-select"
                  ref={node => (this.max = node)}
                />
              </div>
              <div
                className="form__select form__select__bed"
                onClick={() => this.bed.focus()}
              >
                <Select
                  components={{ DropdownIndicator }}
                  styles={colourStyles}
                  options={bed_bath_park}
                  onChange={this._handleChange}
                  openMenuOnFocus={true}
                  id="bedrooms"
                  name="bedrooms"
                  value={bedrooms}
                  placeholder="Bed"
                  isSearchable={false}
                  className="react-select-container"
                  classNamePrefix="react-select"
                  ref={node => (this.bed = node)}
                />
              </div>
              <div
                className="form__select form__select__bath"
                onClick={() => this.bath.focus()}
              >
                <Select
                  components={{ DropdownIndicator }}
                  styles={colourStyles}
                  options={bed_bath_park}
                  onChange={this._handleChange}
                  openMenuOnFocus={true}
                  id="bathrooms"
                  name="bathrooms"
                  value={bathrooms}
                  placeholder="Bath"
                  isSearchable={false}
                  className="react-select-container"
                  classNamePrefix="react-select"
                  ref={node => (this.bath = node)}
                />
              </div>
              <div
                className="form__select form__select__car"
                onClick={() => this.car.focus()}
              >
                <Select
                  components={{ DropdownIndicator }}
                  styles={colourStyles}
                  options={bed_bath_park}
                  onChange={this._handleChange}
                  openMenuOnFocus={true}
                  id="carparks"
                  name="carparks"
                  value={carparks}
                  placeholder="Car"
                  isSearchable={false}
                  className="react-select-container"
                  classNamePrefix="react-select"
                  ref={node => (this.car = node)}
                />
              </div>
              <div className="form__row form__row__filter">
                <div className="left" onClick={this._toggleExpand}>
                  <img src={filter} alt="Refine Search" />
                  <p>Refine Search</p>
                </div>
              </div>
            </div>
          </form>

          {(this.props.type === "all" || this.props.type === "buy") && process.env.GATSBY_LOCATION !== 'nz' && (
            <div className="search__link">
              <Link to={`/classics`}>
                Search <span>Whitefox</span> Classic
              </Link>
            </div>
          )}

          {this.props.type === "apartments" && (
            <div className="search__link">
              <Link to="/buy">
                Search <span>Whitefox</span>
              </Link>
            </div>
          )}
        </div>
      </section>
    )
  }
}

export default SearchForm
